export default __webpack_public_path__ + "static/media/InstagramLogo.d01d986a.svg";